export var PlacementOptions;
(function (PlacementOptions) {
    PlacementOptions["TOP"] = "top";
    PlacementOptions["BOTTOM"] = "bottom";
    PlacementOptions["LEFT"] = "left";
    PlacementOptions["RIGHT"] = "right";
})(PlacementOptions || (PlacementOptions = {}));
